<template>
  <reset-password />
</template>

<script>
import ResetPassword from '@/components/Auth/Home/ResetPassword'
export default {
  components: {
    ResetPassword,
  },
}
</script>

<style></style>
